import { Button, ButtonProps } from '@mui/material';

export interface ParticipateToggleButtonProps extends Omit<ButtonProps, 'onClick' | 'children'> {
  participating: boolean;
  locked?: boolean;
  onToggle: () => void;
}

export const ParticipateToggleButton: React.FC<ParticipateToggleButtonProps> = ({ participating, locked = false, onToggle, ...props }) => {
  return (
    <Button
      size="small"
      variant="contained"
      disabled={locked}
      onClick={event => {
        event.stopPropagation();
        if (!locked) onToggle();
      }}
      sx={{
        fontWeight: 700,
        textTransform: 'none',
        minWidth: 120,
        backgroundColor: participating ? 'participating.main' : 'dustyRose.main',
        color: participating ? 'participating.contrastText' : 'dustyRose.contrastText',
        '&:hover': {
          backgroundColor: participating ? '#c9c9c9' : '#8f5652',
        },
        '&.Mui-disabled': {
          backgroundColor: participating ? 'participating.main' : 'dustyRose.main',
          color: participating ? 'participating.contrastText' : 'dustyRose.contrastText',
          opacity: 0.85,
        },
        ...props.sx,
      }}
      {...props}
    >
      {participating ? 'Participating' : 'Participate'}
    </Button>
  );
};
